import React, { forwardRef, useEffect } from 'react';
import { Checkbox as USWDSCheckbox } from '@ver-uds/uswds-react';
import type { CheckboxProps as USWDSCheckboxProps } from '@ver-uds/uswds-react/dist/FormControls/Checkbox';

export interface CheckboxProps extends USWDSCheckboxProps {
  indeterminate?: boolean;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ indeterminate = false, ...rest }, ref): JSX.Element => {
    const defaultRef = React.createRef<HTMLInputElement>();
    const resolvedRef = ref ?? defaultRef;

    useEffect(() => {
      if (typeof resolvedRef !== 'function' && resolvedRef.current) {
        resolvedRef.current.indeterminate = indeterminate;
      }
    }, [resolvedRef, indeterminate]);

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <USWDSCheckbox ref={resolvedRef} {...rest} />;
  },
);

export default Checkbox;
